import { getTraceId } from '@jucy/logger';
import { Middleware, RequestContext } from '@jucy/rentals-api-client/rentals-api/runtime';

export const defaultHeadersMiddleware: Middleware = {
    pre: async (context: RequestContext) => {
        context.init.headers = {
            ...context.init.headers,
            'X-Jucy-Transaction-Id': getTraceId(),
        };
        if (typeof window === 'undefined' && !(context.init?.headers as Record<string, string>)?.['User-Agent']) {
            context.init.headers = {
                ...context.init.headers,
                'User-Agent': `${process.env.NEXT_PUBLIC_APP_NAME}/1.0.${process.env.NEXT_PUBLIC_BUILD || 0} (+https://www.jucy.com)`,
            };
        }
        return {
            init: context.init,
            url: context.url,
        };
    },
};
